import './App.css';
import ProgramsPage from './pages/programs';
import ksuVideo from './assets/video/ksuVideo.mp4';
import ksuBooklet from './assets/pdf/KSUBooklet.pdf';
const tourUrl = 'https://tour.ksu.edu.sa';

function HomePage() {
  return (
    <main className="home-page min-h-screen overflow-hidden px-6 py-10 text-white">
      <div className="mx-auto flex min-h-[calc(100vh-5rem)] max-w-5xl flex-col items-center justify-center gap-10 text-center">
        <section className="relative z-10 max-w-3xl">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.35em] text-white/75">
            King Saud University
          </p>
          <h1 className="text-4xl font-bold sm:text-6xl">
             Explore KSU
          </h1>
          <p className="mt-5 text-lg leading-8 text-white/85">
            Watch the introduction video, visit the virtual tour, or browse our programs.
          </p>
        </section>

        <section className="relative z-10 w-full max-w-3xl rounded-3xl border border-white/25 bg-white/15 p-4 shadow-2xl shadow-sky-950/40 backdrop-blur">
          <div className="overflow-hidden rounded-2xl bg-slate-950">
            <video
              className="aspect-video w-full"
              controls
              loop
              muted
              // poster="https://www.ksu.edu.sa/sites/default/files/2023-11/ksu-logo.png"
              src={ksuVideo}
            >
              <track kind="captions" />
              Your browser does not support the video tag.
            </video>
          </div>
        </section>

        <nav className="relative z-10 flex flex-col gap-4 sm:flex-row">
          <a
            className="rounded-full bg-white px-8 py-3 font-semibold text-[#0084BD] shadow-lg shadow-sky-950/25 transition hover:-translate-y-1 hover:bg-sky-50"
            href={tourUrl}
            rel="noreferrer"
            target="_blank"
          >
            Open Virtual Tour
          </a>
          <a
            className="rounded-full border border-white/70 px-8 py-3 font-semibold text-white transition hover:-translate-y-1 hover:bg-white/15"
            href="/programs"
          >
            View Programs
          </a>
          <a
            className="rounded-full border border-white/70 px-8 py-3 font-semibold text-white transition hover:-translate-y-1 hover:bg-white/15"
            href={ksuBooklet}
            rel="noreferrer"
            target="_blank"
          >
            KSU Booklet
          </a>
        </nav>
      </div>
    </main>
  );
}

function App() {
  const isProgramsPage = window.location.pathname === '/programs';

  return isProgramsPage ? <ProgramsPage /> : <HomePage />;
}

export default App;
